import { PureComponent } from 'react'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import { withStyles } from '@mui/styles'

const styles = () => ({
  pageBreak: {
    position: 'relative',
    display: 'block',
    width: '100%',
    height: '100%',
    '& img': {
      width: '100%',
      objectFit: 'cover',
    },
  },
  dashedLine: {
    width: '100%',
    height: 2,
    borderTop: '2px dashed',
  },
})
class PageBreakInput extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      hasFocus: false,
    }
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () => this.props.value

  render() {
    const { touched, error, SideElement, classes } = this.props

    const classNames = {
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }

    return (
      <FieldRowWrapper
        className={classNames}
        error={error}
        touched={touched ? touched.toString() : undefined}
      >
        <label className="formz-field-and-label-holder">
          <div className="formz-field-description"></div>
          <span className={`formz-input-pageBreak ${classes.pageBreak}`}>
            <div className={`formz-pageBreak-icon ${classes.dashedLine}`} />
          </span>
          {SideElement && <SideElement />}
        </label>
      </FieldRowWrapper>
    )
  }
}
export default withStyles(styles)(PageBreakInput)
